import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import dash from '../views/Dashboard.vue'
import classes from '../views/Class.vue'
import assign from '../views/Assignment.vue'
import teach from '../views/Teacher.vue'
import register from '../views/Register.vue'
import {auth} from '../components/firebaseinit'
// import db from '../components/firebaseinit'
//import Msg from '../views/messages.vue'
// import profile from '../views/viewProfile.vue'
// import login from '../views/login.vue'

Vue.use(VueRouter)

  const routes = [
  // {
  //   path: '/h',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      requiresGuest: true
    }
  },
  {
    path: '/d',
    name: 'Dashboard',
    component: dash,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/c',
    name: 'Class',
    component: classes,
    meta:{
      requiresAuth: true,
    }
    // ,
    // beta:{
    //   requiresTeacher:true
    // }
  },
  {
    path: '/assign/:id',
    name: 'Assignment',
    component: assign,
    meta:{
      requiresAuth: true
    }
    // ,
    // beta:{
    //   requiresTeacher:true
    // }
  },
  {
    path: '/t',
    name: 'Teacher',
    component: teach,
    // meta:{
    //   requiresAuth: true
    // }
    // ,
    meta:{
      requiresTeacher:true
    }
  },
  {
    path: '/r',
    name: 'Register',
    component: register,
    meta:{
      requiresGuest: true
    }
  }

 /* {
    path: '/msg',
    name: 'Messsages',
    component: Msg
  },
  {
    path: '/login',
    name: 'Login',
    component: login
  },
  {
    path: '/prof',
    name: 'Profile',
    component: profile
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ // '../views/About.vue')
  // }
]

let router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

var teachers=["example@gmail.com"]
// db.collection('teachers').get().then(snapShot => {
//   snapShot.forEach(val => {
//     console.log(val.data().Mail)
//     teachers.push(val.data().Mail)
   

//   })
  // console.log("hello")
  // console.log(teachers.filter(check))
  
  // console.log(auth.currentUser.email)
// })
console.log(teachers)
var use=null
auth.onAuthStateChanged(function(user) {
  console.log(user.email)
  if(user.email==null || user.email==undefined){
    use=null
  }
  else
  use=user.email
  // console.log(use)
  


console.log(use)
const array=teachers.filter(check).length==0




try{
router.beforeEach((to,from,next) => {
  if(to.matched.some(record => record.meta.requiresAuth)){
    if(!use){
      next({
        path:'/',
        query:{
          redirect: to.fullPath
        }
      })
    }
    else{
      console.log(!array)
      if(!array){
        next({
          path:'/t'
          // ,
          // query:{
          //   redirect: to.fullPath
          // }
        })
      }
      else{
      next();
      }
    }
  }
  else if(to.matched.some(record => record.meta.requiresTeacher)){
    if(use){
      console.log(" topath")
      console.log(to.path)
      console.log(teachers)
      
      // const bab=teachers.filter(check).length==0 ? false:true
      // console.log(teachers.filter(check))
      if(to.path=='/t' && array){
        // console.log('heyyou')
        next('/d')
      
     }
      else{
        next()
      }
    }
    else{
      next({
        path:'/',
        query:{
          redirect: to.fullPath
        }
      });
    }}
  else if(to.matched.some(record => record.meta.requiresGuest)){
    // auth.onAuthStateChanged(function(user) {
    //   let a=10
    //   while(a<500){
      console.log(use)
    //   a=a+1
    //   }
      
    //   use=user.email
    if(use!=null){
      if(!array){
      next({
        path:'/t',
        query:{
          redirect: to.fullPath
        }
      })
     }
     else{
      next({
        path:'/d'
        // ,
        // query:{
        //   redirect: to.fullPath
        // }
      })
     }
    }
    else{
      next();
    }
  // })
  }
  
  else{
    next()
  }
})
}
catch(e){
  console.log(e)
}
})
function check(arr){
  if(!auth.currentUser)
  return false
  return arr==auth.currentUser.email
}

export default router
